export const mockHistory = {
    id: "019833ef-db23-7ad7-b53f-21f60d73ce23",
    brand: "Toyota",
    model: "C-HR",
    generation: "",
    color: "Бело-Черный",
    horsePower: 97,
    category: "B",
    maxWeight: 1860,
    minWeight: 1495,
    year: 2017,
    bodyNumber: "NMTKZ3BX20R095411",
    engineNumber: "2ZRV671036",
    crashes: true,
    ownersCount: 1,
    actualRegNumber: "P878OH198",
    regNumbersHistory: {
        requestTime: 1752743233,
        ownersHistory: [
            {
                type: 1,
                owner: "",
                title: "Физическое лицо",
                period: "8 февраля 2022 - н.в.",
                region: "Псковская область"
            }
        ]
    },
    vin: "NMTKZ3BX20R095411",
    ownersHistory: [
        {
            type: 1,
            owner: "",
            title: "Физическое лицо",
            period: "8 февраля 2022 - н.в.",
            region: "Псковская область"
        }
    ],
    pledge: {
        text: "Не обнаружены сведения о нахождении в залоге",
        status: "ok",
        requestTime: 1752743247
    },
    registration: {
        text: "Не обнаружены ограничения на регистрационные действия",
        status: "ok",
        requestTime: 1752743232
    },
    stealing: {
        text: "Не обнаружены сведения о нахождении в розыске",
        status: "ok",
        requestTime: 1752743232
    },
    taxiData: {
        events: null,
        recaps: [
            {
                type: "useInTaxi",
                label: "Сведений об использовании в такси не обнаружено",
                status: "ok",
                description: null
            }
        ]
    },
    carsharingData: {
        events: null,
        recaps: [
            {
                type: "useInCarsharing",
                label: "Сведений о регистрации в каршеринге не обнаружено",
                status: "ok",
                description: null
            }
        ]
    },
    bodyType: "Легковой комби (хэтчбек)",
    driveType: "",
    wheel: "",
    engineType: "Электро-бензиновый",
    transmission: "",
    displacement: 1798,
    doorsCount: 0,
    techInspectionHistory: {
        events: [
            {
                endDate: 1707339600,
                mileage: 35555,
                startDate: 1644267600,
                cardNumber: "012071032200093"
            }
        ]
    },
    insurancePolicies: {
        events: [
            {
                kmb: 0,
                status: "Действует",
                endDate: 1770325200,
                isTransit: false,
                startDate: 1738875600,
                createDate: 1738875600,
                hasTrailer: false,
                companyName: 'АО "СОГАЗ"',
                usageTarget: "",
                policyIsRestrict: false,
                restrictionCount: 0
            }
        ],
        recaps: [
            {
                type: "insurancePolicy",
                label: "Найдены сведения о полисах ОСАГО",
                status: "ok",
                description: null
            }
        ]
    },
    registrationActions: {
        requestTime: 1752743233,
        ownersHistory: [
            {
                type: 1,
                owner: "",
                title: "Физическое лицо",
                period: "8 февраля 2022 - н.в.",
                region: "Псковская область"
            }
        ]
    },
    fines: null,
    paidFines: {
        events: [
            {
                sum: 750,
                status: "Оплачен",
                numPost: "18810547250711128800",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1752256799,
                dateIncident: null
            },
            {
                sum: 4500,
                status: "Оплачен",
                numPost: "0321695310125061700038589",
                koapCode: "",
                koapText:
                    "12.16.5 - Несоблюдение треб.дор.знаков или разметки, запрещ.остановку или стоянку в Москве, Санкт-Петербурге",
                createdAt: 1750183199,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810578240508377702",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1715191199,
                dateIncident: null
            },
            {
                sum: 1000,
                status: "Оплачен",
                numPost: "18810578240314091800",
                koapCode: "",
                koapText: "12.09.3 - Превышение скорости движения ТС от 40 до 60 км/ч",
                createdAt: 1710439199,
                dateIncident: null
            },
            {
                sum: 3000,
                status: "Оплачен",
                numPost: "18810578231027052414",
                koapCode: "",
                koapText:
                    "12.17 ч.1.2 - Движение или остановка на полосе для маршрутных ТС в Москве или в Санкт-Петербурге",
                createdAt: 1698429599,
                dateIncident: null
            },
            {
                sum: 3000,
                status: "Оплачен",
                numPost: "0321695310123092800018682",
                koapCode: "",
                koapText:
                    "12.16.5 - Несоблюдение треб.дор.знаков или разметки, запрещ.остановку или стоянку в Москве, Санкт-Петербурге",
                createdAt: 1695923999,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810578230511060844",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1683827999,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810547230504024157",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1683223199,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810547230414026401",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1681495199,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810578230329351944",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1680112799,
                dateIncident: null
            },
            {
                sum: 2000,
                status: "Оплачен",
                numPost: "18810578230310226303",
                koapCode: "",
                koapText: "12.9.6 - Повторное превышение скорости на 40-60 км/час",
                createdAt: 1678471199,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810550221108775750",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1667930399,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810578221027316969",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1666893599,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810569221025023524",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1666720799,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810578221006662923",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1665079199,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810578221005391780",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1664992799,
                dateIncident: null
            },
            {
                sum: 1500,
                status: "Оплачен",
                numPost: "10673642221009699966",
                koapCode: "",
                koapText: "ст.12.21.4 ч.1",
                createdAt: 1661288400,
                dateIncident: null
            },
            {
                sum: 1000,
                status: "Оплачен",
                numPost: "18810552220816071232",
                koapCode: "",
                koapText: "12.09.3 - Превышение скорости движения ТС от 40 до 60 км/ч",
                createdAt: 1660672799,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810552220804137233",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1659635999,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810552220804137322",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1659635999,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810552220804137381",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1659635999,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810552220804137306",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1659635999,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810524220801035494",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1659362399,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810547220729049964",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1659117599,
                dateIncident: null
            },
            {
                sum: 500,
                status: "Оплачен",
                numPost: "18810524220722036242",
                koapCode: "",
                koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                createdAt: 1658498399,
                dateIncident: null
            }
        ],
        recaps: null,
        requestTime: 1752743232
    },
    eventsOthersHistory: [
        {
            date: 1640736000,
            type: "customs",
            event: "Таможенные сведения",
            source: "Данные о таможенном оформлении",
            mileage: 0,
            description: ""
        },
        {
            date: 1644278400,
            type: "inspection",
            event: "Прохождение технического осмотра",
            source: "Данные о техосмотре",
            mileage: 35555,
            description: ""
        },
        {
            date: 1644278400,
            type: "registration",
            event: "Первичная регистрация",
            source: "Данные о регистрации, Псковская область",
            mileage: 0,
            description: "",
            operationCodeId: 104
        },
        {
            date: 1668239880,
            type: "accident",
            event: "ДТП",
            source: "Данные о ДТП, Санкт-Петербург",
            mileage: 0,
            description: ""
        },
        {
            date: 1711756800,
            type: "to",
            event: "Визит на сервис",
            source: "СТО ЕвроАвто, Санкт-Петербург",
            mileage: 70000,
            description: "##### Выполненные работы:\n- Хранение колёс"
        },
        {
            date: 1729814400,
            type: "to",
            event: "Визит на сервис",
            source: "СТО ЕвроАвто, Санкт-Петербург",
            mileage: 76983,
            description:
                "##### Выполненные работы:\n- ШиномонтажR18 - Разборка/сборка 4-х колес\n- ШиномонтажR18 - Балансировка 4-х колес\n- ШиномонтажR18 - Снятие/установка 4-х колес"
        },
        {
            date: 1730381242,
            type: "repairCalculation",
            event: "Расчет стоимости ремонта",
            source: "Audatex",
            mileage: 77147,
            description:
                "Расчет стоимости ремонта: 817480 RUR <br/> КРЫЛО П ЛОТРЕМОНТИРОВАТЬ: Ремонт<br/>БАМПЕР ПРЕМОНТНАЯ ОКРАСКА K3: Окраска ремонтная (площадь повреждения детали <20-50%)<br/>КРЫЛО П ЛРЕМ.ОКРАСКА <50%: Окраска ремонтная (площадь повреждения детали <20-50%)<br/>БАМПЕР ЗОКРАСКА НОВ.ДЕТ. K1R: Окраска новой детали K1R (ступень AZT окраски пластиковой детали)<br/>ЩИТОК ЗАДКАОКР ДЛЯ НОВ.ДЕТ.ЭТ I: Окраска новой детали<br/>КРЫШКА БАГАЖНИКАОКР ДЛЯ НОВ.ДЕТ.ЭТ I: Окраска новой детали<br/>ПАНЕЛЬ ПОЛА ЗОКРАС. ПОВЕРХН. ЭТ I: Окраска новой детали<br/>ТС В СБ ЗАМЕРИТЬ: Измерение<br/>ФАРА ПР В СБОРЕ81130-F4390*: Замена<br/>НАДПИСЬ КРЫЛО П Л75374-F4020*: Замена<br/>ЗАЩ МОЛД КРЫЛО П Л75602-F4010*: Замена<br/>БАМПЕР З52159-F4908*: Замена<br/>НАКЛАДКА Н БАМПЕРА З52453-F4021*: Замена<br/>УСИЛИТ БАМПЕРА З52023-F4010*: Замена<br/>ЩИТОК ЗАДКА58307-F4021*: Замена<br/>КРЫШКА БАГАЖНИКА67005-F4020*: Замена<br/>УПЛОТНИТ ЗДН ДВЕРИ67881-F4011*: Замена<br/>К-Т КЛЕЯ Д/СТЕКЛА ЗPZ49I00C1131: Замена<br/>МОЛД Н СТЕКЛА З75575-F4010*: Замена<br/>МОЛД Л СТЕКЛА З75574-F4010*: Замена<br/>МОЛД ПР СТЕКЛО З75573-F4010*: Замена<br/>ФОНАРЬ З НАР Л В СБ81560-F4031*: Замена<br/>ФОНАРЬ З НАР ПР В СБ81550-F4031*: Замена<br/>ФОН З ВНУ ПР В СБОРЕ81580-F4021*: Замена<br/>ФАРА ЗАДНЕГО ХОДА81480-F4010*: Замена<br/>ПАНЕЛЬ ПОЛА З58311-F4010*: Замена<br/>ТЕПЛОИЗОЛЯЦ ГЛУШИТЕЛ77641-F4010*: Замена<br/>КОЛЕСНЫЙ ДИСК П Л42611-F4040*: Замена<br/>ЩИТОК ЗАДКА - ЗАМЕНИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>КРЫШКА БАГАЖНИКА - ЗАМЕНИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ЗАДНЕЕ СТЕКЛО - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>БАМПЕР З - ЗАМЕНИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ФОНАРЬ З Л НАРУЖНЫЙ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ФОНАРЬ З ПР НАРУЖНЫЙ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>БАМПЕР З - УСИЛИТЕЛЬ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ОБЛИЦОВКУ С ГРУЗОВОГО ОТДЕЛЕНИЯ С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ПАНЕЛЬ ПОЛА З - ЗАМЕНИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ГЛУШИТЕЛЬ ЗАДНИЙ С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>КОЛЕСО П Л - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ШИНА/ДИСК П Л - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>КОЛЕСО/КОЛЕСА СБАЛАНСИРОВАТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>СТАПЕЛЬ ПЕРЕОБОРУДОВ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>Т/С НА СТАПЕЛЬ - УСТАНОВИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ЗАДНИЙ МОСТ В СБОРЕ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ДАТЧИК/КИ СИСТЕМА ПАРКОВКИ ПЕР С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>БАМПЕР П - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ОБЛИЦОВКА ЛЕВ БАМПЕРА ПЕР С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ОБЛИЦОВКА ПР БАМПЕРА ПЕР С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ФАРЫ - ОБЕ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>РЕШЕТКУ РАДИАТОРА В СНЯТЬ/УСТАНОВИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ВИДЕОКАМЕРА П - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>КРЫЛО П Л - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>НОМЕРН ЗНАК П - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>АКБ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ДЕК ПЛАНКА ДЕК ПЛАНКА ПОРОГ Л С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ЛЮЧОК ТОПЛИВНОГО БАКА - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>СИДЕНЬЕ МНОГОМЕСТН ЗАДНЕЕ В СБОРЕ С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>СПИНКА СИДЕНЬЕ З Л С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>СПИНКА СИДЕНЬЕ З ПР С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ОБЛИЦОВКА НИЖ П МОТОРНОГО ОТСЕКА - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ОБИВКА КРЫЛА - С/У ДОП РАБОТЫ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)"
        }
    ],
    raw: {
        data: {
            head: {
                vin: "NMTKZ3BX20R095411",
                year: 2017,
                brand: "Toyota",
                model: "C-HR",
                createdAt: 1752754030,
                regNumber: "P878OH198"
            },
            fines: null,
            other: [],
            events: {
                owners: {
                    type: "ok",
                    value: 1,
                    description: "1 владелец"
                },
                pledge: {
                    type: "ok",
                    value: false,
                    description: "Залоги не обнаружены"
                },
                crashes: {
                    type: "warning",
                    value: true,
                    description: "1 ДТП"
                },
                bodyRepair: {
                    type: "",
                    value: false,
                    description: ""
                },
                avitoOnSale: {
                    type: "",
                    value: false,
                    description: "",
                    additionalInfo: {
                        url: "",
                        date: 0,
                        price: 0,
                        title: ""
                    }
                },
                publicPerson: {
                    type: "",
                    value: false,
                    description: ""
                },
                firstSellDate: {
                    type: "",
                    value: "",
                    description: ""
                },
                lastMileageRecord: {
                    type: "ok",
                    value: 77147,
                    description: "Пробег 77 147 км"
                },
                dealerDataAvailable: {
                    type: "",
                    value: false,
                    description: ""
                }
            },
            customs: {
                color: null,
                owner: null,
                ecology: null,
                mileage: null,
                createdAt: 1640736000,
                statPrice: null,
                toCountry: "Российская Федерация",
                fromCountry: "Беларусь",
                specification: null
            },
            leasing: null,
            ptsData: {
                pts: [],
                sts: {
                    stsNumber: "9929253582",
                    requestTime: 1752743232
                }
            },
            recalls: [],
            carImage: {
                previewUrl: "",
                originalUrl: ""
            },
            taxiData: {
                events: null,
                recaps: [
                    {
                        type: "useInTaxi",
                        label: "Сведений об использовании в такси не обнаружено",
                        status: "ok",
                        description: null
                    }
                ]
            },
            accidents: {
                requestTime: 1752743232,
                crashesHistory: [
                    {
                        date: 1668239880,
                        type: "Столкновение",
                        region: "Санкт-Петербург",
                        damageMap: ["right-rear-side", "right-front-door", "right-rear-door"],
                        additional: [],
                        damageTypes: [
                            {
                                slug: "right-rear-side",
                                type: "yellow",
                                description: "Правое заднее крыло"
                            },
                            {
                                slug: "right-front-door",
                                type: "red",
                                description: "Правая передняя дверь"
                            },
                            {
                                slug: "right-rear-door",
                                type: "red",
                                description: "Правая задняя дверь"
                            }
                        ]
                    }
                ]
            },
            equipment: {
                body: {
                    title: "Кузов",
                    value: 0,
                    description: ""
                },
                year: {
                    title: "Год выпуска",
                    value: 2017
                },
                brand: {
                    title: "Бренд",
                    value: "Toyota"
                },
                color: {
                    title: "Цвет",
                    value: "Бело-Черный",
                    description: ""
                },
                drive: {
                    title: "Привод",
                    value: 0,
                    description: ""
                },
                model: {
                    title: "Модель",
                    value: "C-HR"
                },
                volume: {
                    title: "Объем двигателя",
                    value: 1798,
                    description: "1 798 см³"
                },
                vehicle: {
                    title: "Тип ТС",
                    value: 0,
                    description: ""
                },
                equipment: {
                    title: "Комплектация",
                    value: ""
                },
                maxWeight: {
                    title: "Разрешенная максимальная масса",
                    value: 1860,
                    description: "1860 кг"
                },
                netWeight: {
                    title: "Масса без нагрузки",
                    value: 1495,
                    description: "1495 кг"
                },
                bodyNumber: {
                    title: "Номер кузова",
                    value: "NMTKZ3BX20R095411"
                },
                engineType: {
                    title: "Тип двигателя",
                    value: "Электро-бензиновый"
                },
                horsepower: {
                    title: "Мощность",
                    value: 97,
                    description: "97 л.с."
                },
                vehicleType: {
                    title: "Тип ТС",
                    value: "Легковой комби (хэтчбек)"
                },
                engineNumber: {
                    title: "Номер двигателя",
                    value: "2ZRV671036"
                },
                modification: {
                    title: "Модификация",
                    value: ""
                },
                transmission: {
                    title: "Трансмиссия",
                    value: 0,
                    description: ""
                },
                vehicleCategory: {
                    title: "Категория ТС",
                    value: "B"
                }
            },
            paidFines: {
                events: [
                    {
                        sum: 750,
                        status: "Оплачен",
                        numPost: "18810547250711128800",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1752256799,
                        dateIncident: null
                    },
                    {
                        sum: 4500,
                        status: "Оплачен",
                        numPost: "0321695310125061700038589",
                        koapCode: "",
                        koapText:
                            "12.16.5 - Несоблюдение треб.дор.знаков или разметки, запрещ.остановку или стоянку в Москве, Санкт-Петербурге",
                        createdAt: 1750183199,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810578240508377702",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1715191199,
                        dateIncident: null
                    },
                    {
                        sum: 1000,
                        status: "Оплачен",
                        numPost: "18810578240314091800",
                        koapCode: "",
                        koapText: "12.09.3 - Превышение скорости движения ТС от 40 до 60 км/ч",
                        createdAt: 1710439199,
                        dateIncident: null
                    },
                    {
                        sum: 3000,
                        status: "Оплачен",
                        numPost: "18810578231027052414",
                        koapCode: "",
                        koapText:
                            "12.17 ч.1.2 - Движение или остановка на полосе для маршрутных ТС в Москве или в Санкт-Петербурге",
                        createdAt: 1698429599,
                        dateIncident: null
                    },
                    {
                        sum: 3000,
                        status: "Оплачен",
                        numPost: "0321695310123092800018682",
                        koapCode: "",
                        koapText:
                            "12.16.5 - Несоблюдение треб.дор.знаков или разметки, запрещ.остановку или стоянку в Москве, Санкт-Петербурге",
                        createdAt: 1695923999,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810578230511060844",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1683827999,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810547230504024157",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1683223199,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810547230414026401",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1681495199,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810578230329351944",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1680112799,
                        dateIncident: null
                    },
                    {
                        sum: 2000,
                        status: "Оплачен",
                        numPost: "18810578230310226303",
                        koapCode: "",
                        koapText: "12.9.6 - Повторное превышение скорости на 40-60 км/час",
                        createdAt: 1678471199,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810550221108775750",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1667930399,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810578221027316969",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1666893599,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810569221025023524",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1666720799,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810578221006662923",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1665079199,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810578221005391780",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1664992799,
                        dateIncident: null
                    },
                    {
                        sum: 1500,
                        status: "Оплачен",
                        numPost: "10673642221009699966",
                        koapCode: "",
                        koapText: "ст.12.21.4 ч.1",
                        createdAt: 1661288400,
                        dateIncident: null
                    },
                    {
                        sum: 1000,
                        status: "Оплачен",
                        numPost: "18810552220816071232",
                        koapCode: "",
                        koapText: "12.09.3 - Превышение скорости движения ТС от 40 до 60 км/ч",
                        createdAt: 1660672799,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810552220804137233",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1659635999,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810552220804137322",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1659635999,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810552220804137381",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1659635999,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810552220804137306",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1659635999,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810524220801035494",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1659362399,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810547220729049964",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1659117599,
                        dateIncident: null
                    },
                    {
                        sum: 500,
                        status: "Оплачен",
                        numPost: "18810524220722036242",
                        koapCode: "",
                        koapText: "12.09.2 - Превышение скорости движения ТС от 20 до 40 км/ч",
                        createdAt: 1658498399,
                        dateIncident: null
                    }
                ],
                recaps: null,
                requestTime: 1752743232
            },
            avitoItems: [],
            diagnostics: null,
            serviceInfo: {
                reportCompleteStatus: {
                    status: "ok",
                    unavailableSources: []
                }
            },
            restrictions: {
                pledge: {
                    text: "Не обнаружены сведения о нахождении в залоге",
                    status: "ok",
                    requestTime: 1752743247
                },
                stealing: {
                    text: "Не обнаружены сведения о нахождении в розыске",
                    status: "ok",
                    requestTime: 1752743232
                },
                registration: {
                    text: "Не обнаружены ограничения на регистрационные действия",
                    status: "ok",
                    requestTime: 1752743232
                }
            },
            ownersHistory: [
                {
                    type: 1,
                    owner: "",
                    title: "Физическое лицо",
                    period: "8 февраля 2022 - н.в.",
                    region: "Псковская область"
                }
            ],
            carsharingData: {
                events: null,
                recaps: [
                    {
                        type: "useInCarsharing",
                        label: "Сведений о регистрации в каршеринге не обнаружено",
                        status: "ok",
                        description: null
                    }
                ]
            },
            crashesHistory: [
                {
                    date: 1668239880,
                    type: "Столкновение",
                    region: "Санкт-Петербург",
                    damageMap: ["right-rear-side", "right-front-door", "right-rear-door"],
                    additional: [],
                    damageTypes: [
                        {
                            slug: "right-rear-side",
                            type: "yellow",
                            description: "Правое заднее крыло"
                        },
                        {
                            slug: "right-front-door",
                            type: "red",
                            description: "Правая передняя дверь"
                        },
                        {
                            slug: "right-rear-door",
                            type: "red",
                            description: "Правая задняя дверь"
                        }
                    ]
                }
            ],
            arbitrationCases: null,
            insurancePayments: [],
            insurancePolicies: {
                events: [
                    {
                        kmb: 0,
                        status: "Действует",
                        endDate: 1770325200,
                        isTransit: false,
                        startDate: 1738875600,
                        createDate: 1738875600,
                        hasTrailer: false,
                        companyName: 'АО "СОГАЗ"',
                        usageTarget: "",
                        policyIsRestrict: false,
                        restrictionCount: 0
                    }
                ],
                recaps: [
                    {
                        type: "insurancePolicy",
                        label: "Найдены сведения о полисах ОСАГО",
                        status: "ok",
                        description: null
                    }
                ]
            },
            eventsOthersHistory: [
                {
                    date: 1640736000,
                    type: "customs",
                    event: "Таможенные сведения",
                    source: "Данные о таможенном оформлении",
                    mileage: 0,
                    description: ""
                },
                {
                    date: 1644278400,
                    type: "inspection",
                    event: "Прохождение технического осмотра",
                    source: "Данные о техосмотре",
                    mileage: 35555,
                    description: ""
                },
                {
                    date: 1644278400,
                    type: "registration",
                    event: "Первичная регистрация",
                    source: "Данные о регистрации, Псковская область",
                    mileage: 0,
                    description: "",
                    operationCodeId: 104
                },
                {
                    date: 1668239880,
                    type: "accident",
                    event: "ДТП",
                    source: "Данные о ДТП, Санкт-Петербург",
                    mileage: 0,
                    description: ""
                },
                {
                    date: 1711756800,
                    type: "to",
                    event: "Визит на сервис",
                    source: "СТО ЕвроАвто, Санкт-Петербург",
                    mileage: 70000,
                    description: "##### Выполненные работы:\n- Хранение колёс"
                },
                {
                    date: 1729814400,
                    type: "to",
                    event: "Визит на сервис",
                    source: "СТО ЕвроАвто, Санкт-Петербург",
                    mileage: 76983,
                    description:
                        "##### Выполненные работы:\n- ШиномонтажR18 - Разборка/сборка 4-х колес\n- ШиномонтажR18 - Балансировка 4-х колес\n- ШиномонтажR18 - Снятие/установка 4-х колес"
                },
                {
                    date: 1730381242,
                    type: "repairCalculation",
                    event: "Расчет стоимости ремонта",
                    source: "Audatex",
                    mileage: 77147,
                    description:
                        "Расчет стоимости ремонта: 817480 RUR <br/> КРЫЛО П ЛОТРЕМОНТИРОВАТЬ: Ремонт<br/>БАМПЕР ПРЕМОНТНАЯ ОКРАСКА K3: Окраска ремонтная (площадь повреждения детали <20-50%)<br/>КРЫЛО П ЛРЕМ.ОКРАСКА <50%: Окраска ремонтная (площадь повреждения детали <20-50%)<br/>БАМПЕР ЗОКРАСКА НОВ.ДЕТ. K1R: Окраска новой детали K1R (ступень AZT окраски пластиковой детали)<br/>ЩИТОК ЗАДКАОКР ДЛЯ НОВ.ДЕТ.ЭТ I: Окраска новой детали<br/>КРЫШКА БАГАЖНИКАОКР ДЛЯ НОВ.ДЕТ.ЭТ I: Окраска новой детали<br/>ПАНЕЛЬ ПОЛА ЗОКРАС. ПОВЕРХН. ЭТ I: Окраска новой детали<br/>ТС В СБ ЗАМЕРИТЬ: Измерение<br/>ФАРА ПР В СБОРЕ81130-F4390*: Замена<br/>НАДПИСЬ КРЫЛО П Л75374-F4020*: Замена<br/>ЗАЩ МОЛД КРЫЛО П Л75602-F4010*: Замена<br/>БАМПЕР З52159-F4908*: Замена<br/>НАКЛАДКА Н БАМПЕРА З52453-F4021*: Замена<br/>УСИЛИТ БАМПЕРА З52023-F4010*: Замена<br/>ЩИТОК ЗАДКА58307-F4021*: Замена<br/>КРЫШКА БАГАЖНИКА67005-F4020*: Замена<br/>УПЛОТНИТ ЗДН ДВЕРИ67881-F4011*: Замена<br/>К-Т КЛЕЯ Д/СТЕКЛА ЗPZ49I00C1131: Замена<br/>МОЛД Н СТЕКЛА З75575-F4010*: Замена<br/>МОЛД Л СТЕКЛА З75574-F4010*: Замена<br/>МОЛД ПР СТЕКЛО З75573-F4010*: Замена<br/>ФОНАРЬ З НАР Л В СБ81560-F4031*: Замена<br/>ФОНАРЬ З НАР ПР В СБ81550-F4031*: Замена<br/>ФОН З ВНУ ПР В СБОРЕ81580-F4021*: Замена<br/>ФАРА ЗАДНЕГО ХОДА81480-F4010*: Замена<br/>ПАНЕЛЬ ПОЛА З58311-F4010*: Замена<br/>ТЕПЛОИЗОЛЯЦ ГЛУШИТЕЛ77641-F4010*: Замена<br/>КОЛЕСНЫЙ ДИСК П Л42611-F4040*: Замена<br/>ЩИТОК ЗАДКА - ЗАМЕНИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>КРЫШКА БАГАЖНИКА - ЗАМЕНИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ЗАДНЕЕ СТЕКЛО - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>БАМПЕР З - ЗАМЕНИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ФОНАРЬ З Л НАРУЖНЫЙ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ФОНАРЬ З ПР НАРУЖНЫЙ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>БАМПЕР З - УСИЛИТЕЛЬ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ОБЛИЦОВКУ С ГРУЗОВОГО ОТДЕЛЕНИЯ С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ПАНЕЛЬ ПОЛА З - ЗАМЕНИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ГЛУШИТЕЛЬ ЗАДНИЙ С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>КОЛЕСО П Л - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ШИНА/ДИСК П Л - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>КОЛЕСО/КОЛЕСА СБАЛАНСИРОВАТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>СТАПЕЛЬ ПЕРЕОБОРУДОВ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>Т/С НА СТАПЕЛЬ - УСТАНОВИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ЗАДНИЙ МОСТ В СБОРЕ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ДАТЧИК/КИ СИСТЕМА ПАРКОВКИ ПЕР С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>БАМПЕР П - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ОБЛИЦОВКА ЛЕВ БАМПЕРА ПЕР С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ОБЛИЦОВКА ПР БАМПЕРА ПЕР С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ФАРЫ - ОБЕ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>РЕШЕТКУ РАДИАТОРА В СНЯТЬ/УСТАНОВИТЬ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ВИДЕОКАМЕРА П - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>КРЫЛО П Л - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>НОМЕРН ЗНАК П - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>АКБ - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ДЕК ПЛАНКА ДЕК ПЛАНКА ПОРОГ Л С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ЛЮЧОК ТОПЛИВНОГО БАКА - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>СИДЕНЬЕ МНОГОМЕСТН ЗАДНЕЕ В СБОРЕ С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>СПИНКА СИДЕНЬЕ З Л С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>СПИНКА СИДЕНЬЕ З ПР С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ОБЛИЦОВКА НИЖ П МОТОРНОГО ОТСЕКА - С/У: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)<br/>ОБИВКА КРЫЛА - С/У ДОП РАБОТЫ: Вспомогательные работы (демонтаж/монтаж, чистка, устранение перекосов и пр.)"
                }
            ],
            registrationActions: {
                requestTime: 1752743233,
                ownersHistory: [
                    {
                        type: 1,
                        owner: "",
                        title: "Физическое лицо",
                        period: "8 февраля 2022 - н.в.",
                        region: "Псковская область"
                    }
                ]
            },
            techInspectionHistory: {
                events: [
                    {
                        endDate: 1707339600,
                        mileage: 35555,
                        startDate: 1644267600,
                        cardNumber: "012071032200093"
                    }
                ]
            },
            vehicleSpecifications: {
                events: [
                    {
                        key: "mainmodel",
                        name: "Обозначение модели",
                        value: "C-HR"
                    },
                    {
                        key: "model",
                        name: "Код модели",
                        value: "ZYX10L-AHXGBW"
                    },
                    {
                        key: "description",
                        name: "Описание",
                        value: "MAXH10,NGX10,50,ZGX10,ZYX1#"
                    },
                    {
                        key: "date",
                        name: "Дата производства",
                        value: "09.2017"
                    },
                    {
                        key: "trimcolor",
                        name: "Код цвета салона",
                        value: "LC20"
                    },
                    {
                        key: "prodperiod",
                        name: "Период производства",
                        value: "10.2016 - ..."
                    },
                    {
                        key: "options",
                        name: "Опции",
                        value: "АКПП/МКПП: CONTINUOUSLY VARIABLE TRANSMISSION;\nРасположение руля: LEFT-HAND DRIVE VEHICLES;\nДвигатель: (2ZRFXE) 1800CC 16-VALVE DOHC EFI;\nРынок сбыта: EUROPE"
                    }
                ],
                requestTime: 1752732432
            },
            extendedSpecifications: {
                events: [
                    {
                        id: 110003,
                        key: "body_type",
                        name: "Тип автомобиля",
                        value: "Внедорожник",
                        valueId: 331231
                    },
                    {
                        id: 110007,
                        key: "drive",
                        name: "Привод",
                        value: "Передний",
                        valueId: 331251
                    },
                    {
                        key: "wheel",
                        name: "Руль",
                        value: "Левый"
                    },
                    {
                        id: 110005,
                        key: "generation",
                        name: "Поколение",
                        value: "I (2016—2019)",
                        valueId: 335497
                    },
                    {
                        id: 110006,
                        key: "engine_type",
                        name: "Тип двигателя",
                        value: "Гибрид",
                        valueId: 331249
                    },
                    {
                        id: 110002,
                        key: "year",
                        name: "Год выпуска",
                        value: "2017",
                        valueId: 331113
                    },
                    {
                        id: 110011,
                        key: "capacity",
                        name: "Мощность двигателя",
                        value: "97.00"
                    },
                    {
                        id: 110012,
                        key: "engine",
                        name: "Объем двигателя",
                        value: "1.80",
                        valueId: 331771
                    },
                    {
                        id: 110004,
                        key: "kolichestvo_dverey",
                        name: "Количество дверей",
                        value: "5",
                        valueId: 331245
                    },
                    {
                        id: 110000,
                        key: "brand",
                        name: "Бренд",
                        value: "Toyota",
                        valueId: 329306
                    },
                    {
                        key: "brandId",
                        name: "Идентификатор бренда",
                        value: "329306"
                    },
                    {
                        id: 110001,
                        key: "model",
                        name: "Модель",
                        value: "C-HR",
                        valueId: 329827
                    },
                    {
                        key: "modelId",
                        name: "Идентификатор модели",
                        value: "329827"
                    }
                ],
                requestTime: 1752732433
            },
            salvageCarAuctionRecords: []
        },
        errors: null,
        success: 1
    },
    status: 0,
    createdAt: "2025-07-22T21:00:13.994422Z"
};